import React from "react"
import type { StepConfig, SelectOption } from "./types"
import { INPUT_CLASS } from "./constants"

interface TagConfigProps {
  config: StepConfig
  tags: SelectOption[]
  onChange: (updates: Partial<StepConfig>) => void
}

export function TagConfig({ config, tags, onChange }: TagConfigProps) {
  return (
    <div className="space-y-1">
      <label className="block text-xs font-medium text-gray-700">Tag</label>
      <select
        value={config.tag_id || ""}
        onChange={(e) => onChange({ tag_id: e.target.value })}
        className={INPUT_CLASS}
      >
        <option value="">Select tag...</option>
        {tags.map((t) => (
          <option key={t.value} value={t.value}>
            {t.label}
          </option>
        ))}
      </select>
      <p className="text-xs text-gray-400">Create tags in workspace settings.</p>
    </div>
  )
}
